import React from "react";
import { useState, useEffect, useRef } from "react";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { Text } from "../../../themes/userq/Text/Text";
import { Dropdown } from "react-bootstrap";
import { DropdownComponent } from "../../../themes/userq/Dropdown/Dropdown";
import moment from "moment";
import { Button } from "../../../themes/userq/Button/Button";
import { useTestBuilderData } from "../../tests/contexts/TestBuilderContext";
import ReportTesterModal from "../../../themes/userq/Modal/report_tester";
import { useLocation } from "react-router-dom";
import { EmptySearchPlaceholder } from "../../../themes/userq/EmptySearchPlaceholder/EmptySearchPlaceholder";
import Skeleton from "react-loading-skeleton";
import { SkeletonTheme } from "react-loading-skeleton";

export default function ScreenRecordingTable({
    screenRecordingData,
    showVideo,
    sortData,
    loadMore,
    loadMoreLoading,
    moreDataAvailable,
    filterOs,
    filterPath,
    updateFilterOs,
    updateFilterPath,
    loadingData,
    test
	

}) {
    const operatingSystem= [
        {
            value: "empty",
            label: "All",
        },
        {
            value: "1",
            label: "Windows",
        },
        {
            value: "2",
            label: "Mac",
        },
        {
            value: "3",
            label: "Linux",
        },
    ];
    const [activeOS, setActiveOS] = useState("empty");

    const [path] = useState([
        {
            value: "empty",
            label: "All",
        },
        {
            value: "1",
            label: "Success",
        },
        {
            value: "0",
            label: "Failure",
        },
        {
            value: "2",
            label: "Gave up",
        }
    ]);
    const [activePath, setActivePath] = useState("empty");

  const handleVideoModal = (videoId) => {
    showVideo(videoId);

    setActiveVideo(videoId.test_result_video.id);
  };
  const calculateTime = (time) => {
    var d = Math.floor(time / (3600 * 24));
    var h = Math.floor((time % (3600 * 24)) / 3600);
    var m = Math.floor((time % 3600) / 60);
    var s = Math.floor(time % 60);

    if (m > 0) {
      return `${m}min ${s}sec`;
    } else if (s > 0) {
      return ` ${s}sec`;
    } else {
      return "-";
    }
  };
  const [currentSort, setCurrentSort] = useState({ value: "", order: "" });
  const [lastSortValue, setLastSortValue] = useState("");
  const handleCurrentSort = (value) => {
    setCurrentSort((prevSort) => ({
      value: value,
      order:
        prevSort.value === value && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };
  const scrollContainerRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    if (lastSortValue) {
      handleCurrentSort(lastSortValue);
    }
  }, [screenRecordingData]);
  const handleSortClick = (value) => {
    setLastSortValue(value);
    sortData(value);
  };
  const handleScroll = () => {
    // Check the scroll position or any other logic you need
    const scrolled = scrollContainerRef.current.scrollTop > 0;

    // Update state based on the scroll position
    setIsScrolled(scrolled);
  };
  useEffect(()=>{

    setActiveOS(filterOs);

  },[filterOs]);

  useEffect(()=>{

    setActivePath(filterPath);

  },[filterPath]);

  useEffect(() => {
    // Attach scroll event listener to the referenced element
    const scrollContainer = scrollContainerRef.current;

        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);

            // Remove the event listener when the component unmounts
            return () => {
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, []);
    const { reportList, setReportList, reportSubmitList, setReportSubmitList } =
        useTestBuilderData();
    const [reportTesterModal, setReportTesterModal] = useState({
        open: false,
        test_result_id: "",
    });
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        var reportListCopy = [...reportList];

    var reportSubmitList = [];
    screenRecordingData.forEach((answer) => {
      if (answer.is_reported == 1) {
        reportListCopy.push(answer.result_id);
      } else if (answer.is_reported == 2) {
        reportSubmitList.push(answer.result_id);
      }
    });
    setReportList(reportListCopy);

        setReportSubmitList(reportSubmitList);
    }, [screenRecordingData]);
    return (
        <>
            <div className="filter-box px-16 py-12 mb-32">
                <div className="row align-items-center">
                    <div className="col-md-3">
                        <div className="d-flex align-items-center">
                            <Icon value={"filter"} size={"medium"} cssClasses={"mr-4x"} />
                            <Text type={"body-text-2"} fontWeight={"medium-font"}>
                                Filter by
                            </Text>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="d-flex justify-content-end">
                            <div className="w-180 mr-32 sm-mr-16 pt-2">
                                <DropdownComponent
                                    name="path"
                                    label="Path"
                                    options={path}
                                    isClearable={false}
									onChange={(data) => {
                                        setActivePath(data.value);
                                        updateFilterPath(data.value);
										console.log(data.value); 
                                    }}
                                    
                                    value={activePath}
                                />
                            </div>
                            <div className="w-180 pt-2">
                                <DropdownComponent
                                    name="operatingSystem"
                                    label="Operating System"
                                    options={operatingSystem}
                                    isClearable={false}
									onChange={(data) => {
                                        setActiveOS(data.value);
                                        updateFilterOs(data.value);
										console.log(data.value); 
                                    }}
                                    value={activeOS}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                ref={scrollContainerRef}
                className={`overflow-x-auto  ${isScrolled ? "scrolled" : ""
                    } max-height-table    responsive-table-scroll`}
            >
                <table className="table screen_recording_table">
                    <thead>
                        <tr>
                            <th>Participant</th>
                            <th>
                                <div className="col-sort justify-content-between">Path</div>
                            </th>
                            <th>
                                <div
                                    className={`${currentSort.value == "screens" ? "asc" : ""
                                        } col-sort justify-content-between `}
                                    onClick={() => {
                                        handleSortClick("screens");
                                    }}
                                >
                                    Screens
                                    <span>
                                        {currentSort.order !== "" &&
                                            currentSort.value == "screens" ? (
                                            currentSort.order === "asc" ? (
                                                <Icon value={"sortup"} />
                                            ) : (
                                                <Icon value={"sortdown"} />
                                            )
                                        ) : (
                                            <Icon value={"sort-icon"} />
                                        )}
                                    </span>
                                </div>
                            </th>
                            <th>
                                <div
                                    className={`${currentSort.value == "clicks" ? "asc" : ""
                                        } col-sort justify-content-between `}
                                    onClick={() => {
                                        handleSortClick("clicks");
                                    }}
                                >
                                    Clicks
                                    <span>
                                        {currentSort.order !== "" &&
                                            currentSort.value == "clicks" ? (
                                            currentSort.order === "asc" ? (
                                                <Icon value={"sortup"} />
                                            ) : (
                                                <Icon value={"sortdown"} />
                                            )
                                        ) : (
                                            <Icon value={"sort-icon"} />
                                        )}
                                    </span>
                                </div>
                            </th>
                            <th>
                                <div
                                    className={`${currentSort.value == "time" ? "asc" : ""
                                        } col-sort justify-content-between `}
                                    onClick={() => {
                                        handleSortClick("time");
                                    }}
                                >
                                    Task time spent
                                    <span>
                                        {currentSort.order !== "" && currentSort.value == "time" ? (
                                            currentSort.order === "asc" ? (
                                                <Icon value={"sortup"} />
                                            ) : (
                                                <Icon value={"sortdown"} />
                                            )
                                        ) : (
                                            <Icon value={"sort-icon"} />
                                        )}
                                    </span>
                                </div>
                            </th>
                            <th>
                                <div
                                    className={`${currentSort.value == "date" ? "asc" : ""
                                        } col-sort justify-content-between `}
                                    onClick={() => {
                                        handleSortClick("date");
                                    }}
                                >
                                    Date
                                    <span>
                                        {currentSort.order !== "" && currentSort.value == "date" ? (
                                            currentSort.order === "asc" ? (
                                                <Icon value={"sortup"} />
                                            ) : (
                                                <Icon value={"sortdown"} />
                                            )
                                        ) : (
                                            <Icon value={"sort-icon"} />
                                        )}
                                    </span>
                                </div>
                            </th>
                            <th>Operating system</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>

                        {screenRecordingData && !loadingData ? (
                            screenRecordingData.map((element, index) => (
                                <tr key={index}>
                                    <td className="min-w-150">{element.tester_type}</td>
                                    <td className="min-w-150">
                                        {
                                            element.is_success == 0 ? (
                                                <>
                                                    {element.is_skipped == 1 ? (
                                                        <div className="d-flex align-items-center">
                                                            <span className="mr-8">
                                                                <Icon
                                                                    value={"forward"}
                                                                    colorClass={"gray-700-svg "}
                                                                    size={"medium"}
                                                                />{" "}
                                                            </span>
                                                            <Text
                                                                type={"body-text-3"}
                                                                cssClasses={"gray-text"}
                                                                fontWeight={"medium-font"}
                                                            >
                                                                Gave up
                                                            </Text>
                                                        </div>
                                                    ) :
                                                        (
                                                            <div className="d-flex align-items-center">
                                                                <span className="mr-8">
                                                                    <Icon
                                                                        value={"error"}
                                                                        colorClass={"danger-200-svg "}
                                                                        size={"medium"}
                                                                    />{" "}
                                                                </span>
                                                                <Text
                                                                    type={"body-text-3"}
                                                                    cssClasses={"red-color-txt"}
                                                                    fontWeight={"medium-font"}
                                                                >
                                                                    Failure path
                                                                </Text>
                                                            </div>
                                                        )
                                                    }
                                                </>


                                            ) : (
                                                <div className="d-flex align-items-center">
                                                    <span className="mr-8">
                                                        <Icon
                                                            value={"success"}
                                                            colorClass={"success-200-svg "}
                                                            size={"medium"}
                                                        />{" "}
                                                    </span>
                                                    <Text
                                                        type={"body-text-3"}
                                                        cssClasses={"green-text"}
                                                        fontWeight={"medium-font"}
                                                    >
                                                        Success path
                                                    </Text>
                                                </div>
                                            )}
                                    </td>
                                    <td className="min-w-120">{element.screens_count} screens</td>
                                    <td className="min-w-100">{element.clicks_count} clicks</td>
                                    <td className="min-w-100">
                                        {calculateTime(element.time_spent)}
                                    </td>
                                    <td className="min-w-150">
                                        {moment(element.created_at).format("DD/MM/Y")}
                                    </td>
                                    <td className="text-center">
                                        {element.system == "mac" && (
                                            <Icon value={"mac"} size={"medium"} />
                                        )}
                                        {element.system == "windows" && (
                                            <Icon value={"windows"} size={"medium"} />
                                        )}
                                        {element.system == "linux" && (
                                            <Icon value={"linux"} size={"medium"} />
                                        )}
                                    </td>
                                    <td className="min-w-240">
                                        {element.test_result_video !== null && element.test_result_video.status !== "error"
 ? (
                                            element.test_result_video.status == "complete" ? (
                                                <div
                                                    className="d-flex align-items-center cursor-pointer"
                                                    onClick={() => {
                                                        handleVideoModal(element);
                                                    }}
                                                >
                                                    <Button
                                                        type={"primary"}
                                                        size={"small"}
                                                        label={ "Play recording"}
                                                        iconLeft={
                                                            <Icon
                                                                value={"play"}
                                                                colorClass={"gray-50-svg "}
                                                                size={"medium"}
                                                            />
                                                        }
                                                        cssclass={activeVideo && element.test_result_video.id === activeVideo ? "active-play-btn" : ""}
                                                        state={activeVideo && element.test_result_video.id === activeVideo ? "active" : ""}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="d-flex align-items-center">
                                                    <Button
                                                        cssclass={"not-available btn-animation"}
                                                        type={"ghost"}
                                                        size={"small"}
                                                        label={"Processing video"}
                                                        iconLeft={
                                                            <Icon
                                                                value={"refresh"}
                                                                colorClass={"gray-50-svg "}
                                                                size={"medium"}
                                                            />
                                                        }
                                                    />
                                                </div>
                                            )
                                        ) : (
                                            <div className="d-flex align-items-center">
                                                <Button
                                                    cssclass={"red-color-txt not-available"}
                                                    type={"ghost"}
                                                    size={"small"}
                                                    label={"Recording not available"}
                                                    iconLeft={
                                                        <Icon
                                                            value={"error"}
                                                            colorClass={"danger-200-svg "}
                                                            size={"medium"}
                                                        />
                                                    }
                                                />
                                            </div>
                                        )}
                                    </td>
                                    <td className="tableDropdown d-flex align-items-center">
                                        {element &&
                                            element.user_type !== "Unknown" &&
                                            (reportList.includes(element.result_id) ||
                                                reportSubmitList.includes(element.result_id)) ? (
                                            reportList.includes(element.result_id) ? (
                                                <div className="d-flex">
                                                    <Icon
                                                        value={"warning"}
                                                        size={"small"}
                                                        colorClass={"danger-red-200 mr-2"}
                                                    />
                                                    <Text
                                                        type={"caption"}
                                                        fontWeight={"medium-font"}
                                                        cssClasses={"red-color-txt"}
                                                    >
                                                        Reported in draft
                                                    </Text>
                                                </div>
                                            ) : (
                                                reportSubmitList.includes(element.result_id) && (
                                                    <div className="d-flex">
                                                        <Icon
                                                            value={"warning"}
                                                            size={"small"}
                                                            colorClass={"danger-red-200 mr-2"}
                                                        />
                                                        <Text
                                                            type={"caption"}
                                                            fontWeight={"medium-font"}
                                                            cssClasses={"red-color-txt"}
                                                        >
                                                            Reported submitted
                                                        </Text>
                                                    </div>
                                                )
                                            )
                                        ) : (
                                            <>
                                                {element &&
                                                    element.user_type !== "Unknown" &&
                                                    location.pathname.substr(1, 1) !== "v" && (
                                                        <span className="hamburger-menu ">
                                                            <Dropdown className="dropdown">
                                                                <Dropdown.Toggle
                                                                    id={"dropdownMenuButton" + element.result_id}
                                                                    className="dropdown-toggle"
                                                                >
                                                                    <span className="menu-item">
                                                                        <Icon
                                                                            value={"Quick menu"}
                                                                            colorClass={
                                                                                "gray-900-svg hamburger-menu-img"
                                                                            }
                                                                        />
                                                                    </span>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className={"hamburger-items"}>
                                                                    <div className="drop-down-link-hold byuser-table-link-hold">
                                                                        <Dropdown.Item
                                                                            onClick={() => {
                                                                                setReportTesterModal({
                                                                                    open: true,
                                                                                    test_result_id: element.result_id,
                                                                                });

                                                                            }}
                                                                        >
                                                                            <span>Report participant</span>
                                                                            <Icon value="warning" size="medium" />
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    )}
                                            </>
                                        )}
                                    </td>
                                </tr>

                            ))
                        ) : [1, 2, 3, 4, 5].map((item) => {
                            return (
                                <tr key={item} className={`old-added-by-user-row`}>
                                    <td>
                                        <Skeleton
                                            width={100}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Skeleton
                                            width={100}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Skeleton
                                            width={100}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Skeleton
                                            width={100}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Skeleton
                                            width={100}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Skeleton
                                            width={100}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Skeleton
                                            width={40}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Skeleton
                                            width={150}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Skeleton
                                            width={30}
                                            height={30}
                                            style={{
                                                borderRadius: "5px",
                                                marginBottom: "0px",
                                            }}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                        {!loadingData && screenRecordingData &&  screenRecordingData.length == 0 && (
                            <tr>
                                <td colSpan={15} className="border-0">
                                    <div className="text-center">
                                        <EmptySearchPlaceholder
                                            type={"rating"}
                                            clearSearch={() => {
                                                setActivePath("empty");
                                                setActiveOS("empty");
                                                updateFilterOs("empty");
                                                updateFilterPath("empty");
                                            }}
                                            cssClass="by-user-placeholder"
                                        />
                                    </div>
                                </td>
                            </tr>
                        )}
          </tbody>
        </table>
       
      </div>
      <div>
      {screenRecordingData &&
          moreDataAvailable &&
          (!loadMoreLoading ? (
            <div className={"load-more-data"}>
              <Button
                type="primary"
                size={`large`}
                label="Load more"
                onClick={() => loadMore()}
              />
            </div>
          ) : (
            <div className={"load-more-data"}>
              <Button
                type="primary"
                size={`large`}
                onClick={() => {}}
                microLoading={true}
              />
            </div>
          ))}
      </div>
      <ReportTesterModal
        test={test}
        openModal={reportTesterModal.open}
        selectedTestResultId={reportTesterModal.test_result_id}
        close={() => {
          setReportTesterModal({ ...reportTesterModal, open: false });
        }}
        confirm={(type, totalParticipantSelected) => {
          setReportTesterModal({ ...reportTesterModal, open: false });
          sessionStorage.setItem("is_reported_tester", "true");
        }}
      />
    </>
  );
}
